import { merge } from 'lodash';

export function bm4000Line(op) {
  return merge(
    {},
    {
      textStyle: {
        color: '#04a4bc'
      },
      tooltip: {
        trigger: 'axis'
      },
      dataZoom: [{ type: 'inside' }],
      backgroundColor: '#121e2c',
      legend: {
        top: 10,
        right: 10,
        textStyle: {
          color: '#04a4bc'
        }
      },
      grid: {
        top: 70,
        bottom: 30,
        left: 25,
        right: 35,
        containLabel: true
      },
      xAxis: {
        type: 'time',
        axisLine: {
          lineStyle: {
            color: '#172749'
          }
        },
        axisLabel: {
          fontSize: '90%'
        },
        splitLine: { show: false },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: '个/升',
        nameGap: 32,
        axisLine: { show: false },
        splitLine: {
          lineStyle: {
            color: '#172749'
          }
        },
        axisLabel: {
          fontSize: '90%'
        }
      },
      series: op.series.map(() => ({
        type: 'line',
        smooth: true,
        symbol: 'circle'
      }))
    },
    op
  );
}

export function bm4000Bar(op, minParticle) {
  minParticle = minParticle || '0.5';
  return merge(
    {},
    {
      textStyle: {
        color: '#04a4bc'
      },
      tooltip: {
        trigger: 'axis'
      },
      color: '#5c89ff',
      title: {
        left: 'center',
        top: 0,
        textStyle: {
          color: '#00eeff',
          fontSize: 21,
          fontWeight: 'bold'
        }
      },
      grid: {
        left: 30,
        right: 80,
        top: 100,
        bottom: 20,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        name: '粒径(μm)',
        nameTextStyle: {
          align: 'left'
        },
        axisLabel: {
          interval: 0,
          fontSize: '90%',
          rotate: -90
        },
        axisLine: {
          lineStyle: {
            color: '#172749'
          }
        },
        splitLine: { show: false },
        axisTick: { show: false },
        data: [
          `${minParticle}-1`,
          '1.0-1.5',
          '1.5-2',
          '2-2.5',
          '2.5-3',
          '3-3.5',
          '3.5-4',
          '4-4.5',
          '4.5-5',
          '5-5.5',
          '5.5-6',
          '6-10',
          '>10.0'
        ]
      },
      yAxis: {
        type: 'value',
        name: '粒子数(个/秒)',
        nameGap: 20,
        axisLine: { show: false },
        splitLine: {
          lineStyle: {
            color: '#172749'
          }
        },
        axisLabel: {
          fontSize: '90%'
        },
        minInterval: 1
      },
      series: [
        {
          type: 'bar',
          barWidth: 20
        }
      ]
    },
    op
  );
}
